export const API_BASE_URL = "https://ams.iridisapps.com/amsapi";
// export const API_BASE_URL = "http://127.0.0.1:5000";
